import { render, staticRenderFns } from "./CCarDescription.vue?vue&type=template&id=3868c138&"
import script from "./CCarDescription.vue?vue&type=script&lang=js&"
export * from "./CCarDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports